.root {
  padding: var(--space-8) var(--page-px) var(--space-24);
  max-width: var(--page-max);
  width: 100%;
}

.head {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-block-end: var(--space-8);
}

.back {
  align-self: flex-start;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface-variant);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.stacked .actions {
  flex-basis: 100%;
}

.stacked .actions > * {
  flex: 1;
}

@media (--window-medium) {
  .stacked .actions {
    flex-basis: auto;
  }

  .stacked .actions > * {
    flex: none;
  }
}

.section {
  margin-block-end: var(--section-gap);
}

.section:last-child {
  margin-block-end: 0;
}
